import { BrandingPreset } from '../../domain';

export const extractColor = (
  config: BrandingPreset['config'],
  color: string,
) => {
  if (color?.startsWith('#')) {
    return color;
  }

  return config[color] || color;
};

/**
 * Expand 3-digit hex to 6-digit (e.g., #ABC -> #AABBCC)
 */
export const expandHexColor = (hex: string): string => {
  if (/^#[0-9A-F]{3}$/i.test(hex)) {
    const r = hex[1];
    const g = hex[2];
    const b = hex[3];
    return `#${r}${r}${g}${g}${b}${b}`.toUpperCase();
  }
  return hex.toUpperCase();
};
